<template>
<div id="imger">
  <div class="logoBar">
      <h1></h1>
      <a href="http://www.jsdnn.com/" target="_blank">狄诺尼官网</a>
  </div>
  <div>
    <el-form :model="loginForm" :rules="rules2" ref="loginForm" label-position="left" label-width="0px" class="demo-ruleForm login-container">
      <h2 class="title">用户登录</h2>
      <el-form-item prop="phone">
        <span class="iconfont icon-dianhua"></span>
        <el-input class="phone" type="text" v-model="loginForm.phone" auto-complete="off" placeholder="手机号码"></el-input>
      </el-form-item>
      <div style="height:10px;width:100%"></div>
      <el-form-item prop="password">
        <span class="iconfont icon-mima"></span>
        <el-input class="phone" type="password" v-model="loginForm.password"
        @keyup.enter.native="handleSubmit2" auto-complete="off" placeholder="密码"></el-input>
      </el-form-item>
      <!-- <el-radio-group class="zhcss" v-model="radio">
        <el-radio class="grzh" :label="3">个人账户</el-radio>
        <el-radio class="qyzh" :label="6">企业账户</el-radio>
      </el-radio-group> -->
      <div style="height:20px;width:100%"></div>
      <el-form-item style="width:100%;margin-bottom:0px">
        <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit2" :loading="logining">登录</el-button>
      </el-form-item>
      <div class="tips">
            <router-link  :to="{path:'/register'}" >免费注册</router-link>
            <router-link  :to="{path:'/forget'}" >忘记密码</router-link>
        </div>
      
    </el-form>
  </div>
  <div class="ftBox">
      <p>江苏狄诺尼信息技术有限责任公司</p>
      <p>CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906</p>
  </div>
</div>
</template>

<script>
  import axios from 'axios'
  import { API__code, API__login } from '../api/index.js'
  import { requestLogin } from '../api/api';
  export default {
    data() {
      return {
        radio: 3,
        logining: false,
        loginForm: {
          phone: '',
          password: ''
        },
        rules2: {
          phone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ]
        },
        checked: true
      };
    },
    mounted() {
        this.clearCookie();
        this.getCookie();
    },
    methods: {
      handleSubmit2(formName) {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.login();
          } else {
            this.$message.error('请正确输入登录账号和密码..');
            return false;
          }
        });
      },
      // 登录
      login() {
        this.pageLoading = true;
        let param ={
          password:this.loginForm.password,
          phone:this.loginForm.phone,
          userType:'0',//用户类型
        }
        API__login.login(param)
        .then( (res) => {
          if( res.data.code == API__code.SUCCESS ) {
            this.$message({
              message: '登录成功',
              type: 'success'
            });
            // this.$store.dispatch('login', res.data.data);
            // this.$store.dispatch('removeMenuInfo');
            // var checkStr = res.data.checkStr;
            // var userID = res.data.userID;
            // const self = this;
            // self.setCookie("loginInfo","checkStr",checkStr);
            // self.setCookie("loginInfo","userID",userID);
            var token = res.data.data.phone;
            this.setCookie("dnnyptInfo","dnnypt_token",token);
            var name = res.data.data.name;
            if(name){
              sessionStorage.setItem('user', name);
            }else{
              sessionStorage.setItem('user', token);
            }
            var modules = res.data.data.module;
            if(modules){
              sessionStorage.setItem('module', modules);
            }
            var checkCode = res.data.data.checkCode
            this.setCookie("dnnyptInfo","dnnypt_checkCode",checkCode);
            var id = res.data.data.id;
            this.setCookie("dnnyptInfo","dnnypt_id",id);

            this.$router.push({path: 'productList'});
          }else {
            this.$message.error(res.data.message);
          }
          this.pageLoading = false;
        }).catch( e => {
          this.$message.error('服务器异常，请您稍后再试..');
          this.pageLoading = false;
        });
      },
      //设置cookie
      setCookie(c_name, c_pwd, exdays) {
        var exdate = new Date(); //获取时间
        exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
        if(c_name == "dnnyptInfo"){
          window.document.cookie = c_pwd + "=" + exdays + ";path=/;expires=" + exdate.toGMTString();
        }else{
          //字符串拼接cookie
          window.document.cookie = "name" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
          window.document.cookie = "password" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
        }
      },
      //读取cookie
      getCookie: function() {
          if (document.cookie.length > 0) {
              var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
              for (var i = 0; i < arr.length; i++) {
                  var arr2 = arr[i].split('='); //再次切割
                  //判断查找相对应的值
                  if (arr2[0] == 'name') {
                      this.loginForm.name = arr2[1]; //保存到保存数据的地方
                  } else if (arr2[0] == 'password') {
                      this.loginForm.password = arr2[1];
                  }
              }
          }
      },
      //清除cookie
      clearCookie: function() {
          this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
      },
    }
  }

</script>

<style lang="scss" scoped>
  .login-container {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    
    width: 350px;
    padding: 35px 50px 35px 50px;
    background: rgba(0,0,0,0.4);
   // opacity: 0.5;
    //border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #214976;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #fff;
      text-align: center;
      // margin-top: 20px;
      // margin-bottom: 20px;
      color: rgb(255, 255, 255);
      text-shadow: rgb(0, 0, 0) 0px 2px 4px;
      font-size: 20px;
      font-weight: normal;
    }
    .remember {
      margin: 0px 0px 35px 0px;
      color:#fff;
    }
  }
  
  #imger{    
      width: 100%;
      height: 100%;
      background:  url('./img/loginBg.jpg');
      background-size: cover;
      // position: fixed;
      // z-index: -10;
    }
  .logoBar {
    background: rgba(0,0,0,.3);
    height: 60px;
    width: 100%;
    position: absolute;
    z-index: 2;
}
.logoBar h1 {
    margin-top: 8px;
    margin-left: 20px;
    background: url(./img/logo.png) no-repeat;
    background-size: 100%;
    width: 140px;
    height: 43px;
    float: left;
}
.logoBar a {
    float: right;
    color: #fff;
    margin-top: 20px;
    font-size: 14px;
    margin-right: 20px;
    border-bottom: 0.55px solid #666;
    padding-bottom: 1px;
}
.ftBox {
    width: 100%;
    height: 60px;
    padding-top: 10px;
    background: rgba(0,0,0,.5);
    text-align: center;
    font-size: 13px;
    color: #fff;
    margin:0;
    display: block;
    position:absolute;
    left:0;
    bottom:0;
}
.ftBox p {
    margin: 0;
}
div {
    display: block;
}
.zhcss {
  padding-bottom: 20px;
  color:#fff;
}
.el-radio {
  color:#fff
}
.tips {
    float: right;
    margin: 30px 0 0 0;
}
.tips a {
    color: rgb(204, 204, 204);
    margin-left: 20px;
    cursor: pointer;
}

</style>


// WEBPACK FOOTER //
// Login.vue?5b9be684